export default __webpack_public_path__ + "static/lets-talk-wood-e07e0eef97a26e84945db661008a6986.jpg";